module.exports = "<% _.each(selfService, function(itm, idx){ %> <a href=\"<%= itm.link %>\" target=_blank class=right_service_href_cls id=\"<%= itm.id %>\"> <img src=\"<%= itm.icon %>\"/> <span><%= itm.name %></span> </a> <%if(idx == 3){%> <br/> <%}%> <% }) %> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/q&a/selfService/itemTpl.html
// module id = 254
// module chunks = 0